export const MOBILE_APP_REFERRALS = ['chatbotOwnerApp', 'chatbotStudioApp'];
